import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';

export const PositionChangeDecisionModal = ({ request, action, saving, error, onClose, onConfirm }) => {
    const titleId = useId();
    const [reason, setReason] = useState('');
    const approve = action === 'approve';
    return (
        <Dialog open fullWidth maxWidth="sm" aria-labelledby={titleId}
            onClose={saving ? undefined : onClose}>
            <DialogTitle id={titleId}>{approve ? 'Approve' : 'Reject'} position change?</DialogTitle>
            <form onSubmit={(event) => { event.preventDefault(); onConfirm(reason.trim()); }}>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Typography>{request.employee.firstName} {request.employee.lastName} ({request.employee.email})</Typography>
                    <Typography>Current position: {request.currentPosition || 'Not set'}</Typography>
                    <Typography>Requested position: {request.requestedPosition}</Typography>
                    {error && <Alert severity="error">{error}</Alert>}
                    {!approve && <TextField label="Rejection reason (optional)" multiline minRows={2}
                        value={reason} onChange={(event) => setReason(event.target.value)}
                        disabled={saving} inputProps={{ maxLength: 1000 }} helperText={`${reason.length}/1000`} />}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} disabled={saving}>No</Button>
                    <Button type="submit" variant="contained" disabled={saving}>
                        {saving ? 'Saving…' : 'Yes'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

PositionChangeDecisionModal.propTypes = {
    request: PropTypes.shape({
        employee: PropTypes.shape({
            firstName: PropTypes.string, lastName: PropTypes.string, email: PropTypes.string,
        }).isRequired,
        currentPosition: PropTypes.string,
        requestedPosition: PropTypes.string.isRequired,
    }).isRequired,
    action: PropTypes.oneOf(['approve', 'reject']).isRequired,
    saving: PropTypes.bool.isRequired,
    error: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
